import { keysOf } from '@upright/common/utils';
import { validate } from 'email-validator';
import { UseMutationResult } from '@tanstack/react-query';
import { SubscriptionTier } from '../../../../../common/activities/contact-forms/company-subscription/subscription-tiers';
import { CompanyInfo, PersonalInfo } from '../../../../../common/activities/contact-forms/company-subscription/types';

export function validatePersonalInfo(input: Partial<PersonalInfo>): input is PersonalInfo {
  const allKeysToValidate = keysOf(personalInfoValidators);
  for (const key of allKeysToValidate) {
    if (!personalInfoValidators[key](input[key])) {
      return false;
    }
  }
  return true;
}

export const personalInfoValidators: {
  [key in keyof PersonalInfo]: (value: PersonalInfo[key] | undefined) => boolean;
} = {
  firstName: value => !!value,
  lastName: value => !!value,
  email: value => !!value && validate(value),
};

export function validateCompanyInfo(input: Partial<CompanyInfo>, tier: SubscriptionTier): input is CompanyInfo {
  const validated = {
    name: companyInfoValidators.name(input.name, tier),
    size: companyInfoValidators.size(input.size, tier),
  };
  const failed = Object.values(validated).filter(d => !d);
  return !failed.length;
}

export const companyInfoValidators: {
  [key in keyof CompanyInfo]: (value: CompanyInfo[key] | undefined, tier: SubscriptionTier) => boolean;
} = {
  name: value => !!value,
  size: (_value, _tier) => {
    /**
     * OA: Not in use as of 4/2023. Still worth to keep present in codebase as long as the tiered subscription modal is used;
     * we might want to bring this back. Search for this same comment to spot other locations with this thing.
     */
    // if (tier === SubscriptionTier.STANDARD) {
    //   return !!value;
    // }
    return true;
  },
};

export function validatePromoCode(code: string | undefined, query: UseMutationResult<{ code: string }, any, any>) {
  if (!code) {
    return true;
  }
  if (query.status === 'success' && code === query.data.code) {
    return true;
  }
  return false;
}

export function validateTermsAccepted(_accepted: boolean, _tier: SubscriptionTier) {
  /**
   * OA: Not in use as of 4/2023. Still worth to keep present in codebase as long as the tiered subscription modal is used;
   * we might want to bring this back. Search for this same comment to spot other locations with this thing.
   */
  // if (tier === SubscriptionTier.STANDARD) {
  //   return accepted;
  // }
  return true;
}
